export enum ProtectedAreasIbat {
  'Ia' = 'Ia',
  'Ib' = 'Ib',
  'II' = 'II',
  'III' = 'III',
  'IV' = 'IV',
  'V' = 'V',
  'VI' = 'VI',
  'not_assigned' = 'Not_Assigned',
}

export enum ProtectedAreasOsm {
  'cultural_and_indigenous_area' = 'Cultural_&_Indigenous_Area',
  'habitat_and_species_management_area' = 'Habitat_&_Species_Management_Area',
  'internationally_and_nationally_recognized_area' = 'Internationally_&_Nationally_Recognized_Area',
  'strictly_protected_area' = 'Strictly_Protected_Area',
  'national_park_natural_monument' = 'National_Park_/_Natural_Monument',
  'protected_landscape_and_sustainable_use_area' = 'Protected_Landscape_&_Sustainable_Use_Area',
  'water_protection_area' = 'Water_Protection_Area',
  'unclassified' = 'Unclassified',
}

export const ProtectedAreas = {
  ...ProtectedAreasIbat,
  ...ProtectedAreasOsm,
} as const;

export const reverseProtectedAreas = Object.fromEntries(
  Object.entries(ProtectedAreas).map(([k, v]) => [v, k]),
) as Record<(typeof ProtectedAreas)[keyof typeof ProtectedAreas], keyof typeof ProtectedAreas>; // Necessary to get the enum key from the value since the BE is returning values that can't be used as object keys

export const PROTECTED_AREAS_IBAT_COLORS: Record<ProtectedAreasIbat, string> = {
  [ProtectedAreasIbat.Ia]: '#EEF100',
  [ProtectedAreasIbat.Ib]: '#FEDB8C',
  [ProtectedAreasIbat.II]: '#AB7D75',
  [ProtectedAreasIbat.III]: '#EBECCC',
  [ProtectedAreasIbat.IV]: '#99CAE2',
  [ProtectedAreasIbat.V]: '#4B7BB7',
  [ProtectedAreasIbat.VI]: '#F2A900',
  [ProtectedAreasIbat.not_assigned]: '#9E9E9E',
} as const;

export const PROTECTED_AREAS_OSM_COLORS: Record<ProtectedAreasOsm, string> = {
  [ProtectedAreasOsm.strictly_protected_area]: '#FAFF62',
  [ProtectedAreasOsm.national_park_natural_monument]: '#99DEFF',
  [ProtectedAreasOsm.habitat_and_species_management_area]: '#FEDB8C',
  [ProtectedAreasOsm.protected_landscape_and_sustainable_use_area]: '#63A8FF',
  [ProtectedAreasOsm.water_protection_area]: '#FFC540',
  [ProtectedAreasOsm.cultural_and_indigenous_area]: '#EEF100',
  [ProtectedAreasOsm.internationally_and_nationally_recognized_area]: '#FF907D',
  [ProtectedAreasOsm.unclassified]: '#B46DFF',
} as const;
